import { render, staticRenderFns } from "./documento_de_cotizacion.vue?vue&type=template&id=fbfe6274&lang=pug&"
import script from "./documento_de_cotizacion.vue?vue&type=script&lang=js&"
export * from "./documento_de_cotizacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports